<template>
    <div>
        <div
            :class="`playing ${isPlaying ? 'isPlaying' : ''}`"
            @click="openNowPlaying"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 200 200"
                style="width: 40px; margin-left: -4px"
            >

                <g
                    id="Layer_2"
                    data-name="Layer 2"
                >
                    <g
                        id="Layer_1-2"
                        data-name="Layer 1"
                    >
                        <circle
                            class="cls-1"
                            cx="107.3"
                            cy="107.3"
                            r="107.3"
                        />
                        <path
                            class="cls-2"
                            d="M48.12,104.39c-8.22,0-14.89,11.7-14.89,26.12s6.67,26.12,14.89,26.12a8.35,8.35,0,0,0,2.16-.31V104.7A8.8,8.8,0,0,0,48.12,104.39Z"
                        />
                        <path
                            class="cls-2"
                            d="M163.47,156.63c8.22,0,14.88-11.69,14.88-26.12s-6.66-26.12-14.88-26.12a8.67,8.67,0,0,0-2.16.31v51.62A8.23,8.23,0,0,0,163.47,156.63Z"
                        />
                        <line
                            class="cls-3"
                            x1="84.16"
                            y1="118.62"
                            x2="125.1"
                            y2="118.62"
                        />
                        <line
                            class="cls-3"
                            x1="91.59"
                            y1="126.05"
                            x2="132.53"
                            y2="126.05"
                        />
                        <line
                            class="cls-3"
                            x1="80.44"
                            y1="134.99"
                            x2="121.38"
                            y2="134.99"
                        />
                        <line
                            class="cls-3"
                            x1="87.88"
                            y1="142.42"
                            x2="128.82"
                            y2="142.42"
                        />
                        <path
                            class="cls-4"
                            d="M147.75,156.09l12.52,0V101.32a55.64,55.64,0,0,0-111.28,0v55l15.61,0V102a40.85,40.85,0,0,1,81.7,0v54.05Z"
                        />
                    </g>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { Howl } from 'howler';
import VueHowler from 'vue-howler';

var pgapMixin = {
    created: function () {
        console.log('Pgap mixin loaded');
    },
    data () {
        return {
            duration: 0,
            seek: 0,
            progress: 0,
        };
    },
    methods: {
    }
}

export default {
    mixins: [pgap ? pgapMixin : VueHowler],
    store: ['api', 'user', 'isPlaying', 'isLoadingAudio', 'isPlayingContent', 'isPlayingData', 'audioSources', 'unitsIndex'],
    data () {
        return {
            media: null,
            hasBgSounds: false,
            updaterFunc: null,
        };
    },
    watch: {
        isPlayingContent: function () {
            if (this.isPlayingData.type === 'game') {
                this.hasBgSounds = true;
            } else {
                this.hasBgSounds = false;
            }
        },
        audioSources: function () {
            if (pgap && this.audioSources[0]) {
                // console.log('Audio change', this.audioSources[0]);
                this.isPlaying = false;
                this.isLoadingAudio = true;
                if (device.platform !== 'iOS') {
                    if (this.media && this.media.stop) this.media.stop();
                }
                //eslint-disable-next-line no-undef
                this.media = new Media(this.audioSources[0], this.mediaSuccess, this.mediaError, this.mediaStatus);
                // this.media.setVolume(1);
                setTimeout(() => {
                    this.$f7.preloader.hide();
                    if (this.audioSources[0] !== '') {
                        this.$events.fire('player:trueplay');
                    }
                }, 300);
            } else if (this.audioSources[0]) {
                this.isLoadingAudio = true;
            }
        }
    },
    mounted: function () {
        // console.log('remount audio');
        this.isPlaying = false;
        this.isLoadingAudio = false;
    },
    created: function () {
        // Yes but this is not correct because global player so cannot check here
        // maybe on watch of isPlayingData
        if (pgap) {
            document.addEventListener("deviceready", () => {
                setTimeout(() => {
                    // eslint-disable-next-line no-undef
                    this.media = new Media('');
                }, 1000);
            }, false);
        }
        if (!pgap) {
            this.$on('load', () => {
                console.log('Global player load', this.audioSources[0]);
                setTimeout(() => {
                    this.$f7.preloader.hide();
                    if (this.audioSources[0] !== '') {
                        if (this.isPlayingData && this.isPlayingData.type === 'game') this.hasBgSounds = true;
                        this.$events.fire('player:trueplay');
                    }
                }, 300);
            });
            this.$on('end', () => {
                console.log('Global player end');
                this.$events.fire('player:stop');
            });
            this.$on('play', () => {
                console.log('Global player play', this.hasBgSounds);
            })
            this.$on('pause', () => {
                console.log('Global player pause');
            })
        }
        // moved all this to created to try fix doubleplay
        // },
        // mounted: function () {
        //
        console.log('Player loaded');
        this.$events.off('player:trueplay');
        this.$events.on('player:trueplay', () => {
            console.log('Player:trueplay');
            if (pgap) {
                this.media.play();
            } else {
                this.play();
            }
            this.isPlaying = true;
            this.updater();
        });
        this.$events.off('player:play');
        this.$events.on('player:play', () => {
            console.log('Player:true');
            // if (this.audioLoaded) {
            if (pgap) {
                this.media.play();
            } else {
                this.play();
            }
            this.isPlaying = true;
            // } else {
            //     this.$f7.preloader.show();
            // }
        });
        this.$events.off('player:seek');
        this.$events.on('player:seek', (percentage) => {
            console.log('Player:seek', percentage);
            if (pgap) {
                // this work with milisecs
                this.media.seekTo(percentage * this.duration * 10);
            } else {
                this.setProgress(percentage / 100);
            }
        });
        this.$events.off('player:stop');
        this.$events.on('player:stop', (reset) => {
            console.log('Player:stop', reset);
            clearInterval(this.updaterFunc);
            if (pgap) {
                if (device.platform === 'iOS') {
                    this.media.seekTo(0);
                    this.media.stop();
                    setTimeout(() => {
                        this.media.stop();
                    }, 300);
                } else {
                    this.media.stop();
                }
            } else {
                this.stop();
            }
            this.isPlaying = false;
            this.$events.fire(`player:status:${this.isPlayingContent}`, {
                progress: 0,
                seek: 0,
                duration: this.duration,
            });
            if (reset) {
                // alert();
                // this.audioSources = [];
                // this.audioLoaded = false;
            }
        });
        this.$events.off('player:togglePlayback');
        this.$events.on('player:togglePlayback', () => {
            console.log('Player:togglePlayback');
            if (pgap) {
                if (this.isPlaying) {
                    this.media.pause();
                } else {
                    this.media.play();
                }
            } else {
                this.togglePlayback();
            }
            this.isPlaying = !this.isPlaying;
            this.updater();
        });

    },
    beforeDestroy: function () {
        this.$events.off('player:trueplay');
        this.$events.off('player:play');
        this.$events.off('player:seek');
        this.$events.off('player:stop');
        this.$events.off('player:togglePlayback');
    },
    methods: {
        openNowPlaying: function () {
            let url = this.isPlayingContent;
            // console.log(url, f7.views['popup'].router.currentRoute.path)
            if (this.isPlayingContent.indexOf('/topics/') > -1) {
                if (f7.views['main'].router.currentRoute.path !== url) {
                    f7.views['main'].router.navigate(url, {
                        animate: false,
                        clearPreviousHistory: false,
                    });
                    if (!pgap) window.history.pushState(null, "", '/web' + url);
                }
                return;
            } else if (f7.views['popup'].router.currentRoute.path !== url) {
                f7.views['popup'].router.navigate(url, {
                    animate: false,
                    clearPreviousHistory: false,
                });
                if (!pgap) window.history.pushState(null, "", '/web' + url);
            }
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 350);
        },
        mediaSuccess: function (e) {
            console.log('mediaSuccess', e);
        },
        mediaError: function (e) {
            console.log('mediaError', e);
            // MediaError.MEDIA_ERR_ABORTED = 1
            // MediaError.MEDIA_ERR_NETWORK = 2
            // MediaError.MEDIA_ERR_DECODE = 3
            // MediaError.MEDIA_ERR_NONE_SUPPORTED = 4
            if (2 === e) {
                f7.dialog.alert('Could not download audio. Networking issues.');
                this.isLoadingAudio = false;
            }
        },
        getDuration: function () {
            if (pgap && device.platform === 'iOS') {
                this.duration = this.media.getDuration();
                return;
            }
            // code taken as is from cordova media example
            var counter = 0;
            var timerDur = setInterval(() => {
                counter = counter + 100;
                if (counter > 5000) {
                    clearInterval(timerDur);
                }
                var dur = this.media.getDuration();
                if (dur > 0) {
                    clearInterval(timerDur);
                    this.duration = dur;
                }
            }, 100);
        },
        mediaStatus: function (e) {
            console.log('MediaStatus', e);
            // Media.MEDIA_NONE = 0;
            // Media.MEDIA_STARTING = 1;
            // Media.MEDIA_RUNNING = 2;
            // Media.MEDIA_PAUSED = 3;
            // Media.MEDIA_STOPPED = 4;
            if (e === 2) {
                this.isPlaying = true;
                this.getDuration();
            } else if (e === 3 || e === 4) {
                this.isPlaying = false;
            }
        },
        updater: function () {
            clearInterval(this.updaterFunc);
            let update = () => {
                if (pgap) {
                    return this.media.getCurrentPosition((position) => {
                        if (position > -1 && this.duration > 0) {
                            let progress = position / this.duration;
                            this.progress = isNaN(progress) ? 0 : progress;
                            this.seek = isNaN(position) ? 0 : position;
                        }
                        if (this.isLoadingAudio && !isNaN(parseFloat(position)) &&
                            position > 0) {
                            this.isLoadingAudio = false;
                        }
                        this.$events.fire(`player:status:${this.isPlayingContent}`, {
                            progress: this.progress,
                            seek: this.seek,
                            duration: this.duration,
                        });
                        if (this.isPlayingData.id && this.unitsIndex[this.isPlayingData.id]) {
                            try {
                                Vue.set(this.unitsIndex[this.isPlayingData.id], 'progress', parseInt(this.progress * 100, 10));
                            } catch (e) {
                                console.error('[Player] could not update progress');
                            }
                        }
                    });
                }
                if (this.isLoadingAudio &&
                    this.progress > 0) {
                    this.isLoadingAudio = false;
                }
                this.$events.fire(`player:status:${this.isPlayingContent}`, {
                    progress: this.progress,
                    seek: this.seek,
                    duration: this.duration,
                });
                if (this.isPlayingData.id && this.unitsIndex[this.isPlayingData.id]) {
                    try {
                        Vue.set(this.unitsIndex[this.isPlayingData.id], 'progress', parseInt(this.progress * 100, 10));
                    } catch (e) {
                        console.error('[Player] could not update progress');
                    }
                }
            }
            this.updaterFunc = setInterval(update, 300);
        }
    },
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';

.cls-1,
.cls-3 {
    fill: none;
}
.cls-2 {
    fill: #444;
}
.cls-3 {
    stroke: #444;
    stroke-width: 2.13px;
}
.cls-3,
.cls-4 {
    stroke-miterlimit: 10;
}
.cls-4 {
    fill: transparent;
    stroke: #444;
    stroke-width: 2px;
}

.playing {
    position: absolute;
    background-color: rgba(
        var(--f7-toolbar-bg-color-rgb, var(--f7-bars-bg-color-rgb)),
        var(--f7-bars-translucent-opacity)
    );
    -webkit-backdrop-filter: saturate(180%) blur(var(--f7-bars-translucent-blur));
    backdrop-filter: saturate(180%) blur(var(--f7-bars-translucent-blur));
    color: white;
    bottom: 95px;
    left: -1000px;
    transition: left 1.2s;
    padding: 2px 6px 0px;
    border-radius: 0 10px 10px 0;
    // border: 0.3px solid gray;
    z-index: 100001;
    i {
        font-size: 30px;
    }
    &.isPlaying {
        left: -1px;
    }
}
</style>
